import { render, staticRenderFns } from "./BookinResources.vue?vue&type=template&id=78932a60&scoped=true&"
import script from "./BookinResources.vue?vue&type=script&lang=js&"
export * from "./BookinResources.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=78932a60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78932a60",
  null
  
)

export default component.exports